import React from 'react'

import { Grid, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { Controller, useForm } from 'react-hook-form'
import PropTypes from 'prop-types'

import { BaseDialog, Label, LoadingFeedback } from 'components'

import * as service from 'service'
import helpers from 'helpers'

import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'

const DialogManageTag = ({
  dataProcessId,
  dataProcessTags = [],
  setOpen,
  open,
  setIsLoading,
  refresh = () => {},
}) => {
  const snackbar = useSnackbar()

  const tags = dataProcessTags.map((dataProcessTag) => dataProcessTag?.tag)
  const { handleSubmit, errors, control } = useForm({
    defaultValues: { dataProcessTags: tags, newTags: '' },
  })

  const { response: responseTags, isLoading } = useFetch(
    service.dponet.tags.get,
    { minimal: true },
  )

  const allTags = responseTags?.data?.tags

  const onSubmit = async (data) => {
    setIsLoading(true)
    setOpen(false)
    try {
      const newTags = data?.newTags
        .split(',')
        .map((val) => val.trim())
        .filter((val) => val !== '')

      const selectedTagIds = data?.dataProcessTags?.map((tag) => tag?.id) || []

      await service.dponet.dataProcessTags.create({
        dataProcessTag: {
          newTags,
          selectedTags: selectedTagIds,
        },
        dataProcessId,
      })

      snackbar.open({
        message: 'Classificadores atualizados com sucesso!',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(
            error?.response?.data?.error,
            false,
          ) || 'Ocorreu um erro, tente novamente',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
      refresh()
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Novo Classificador"
      dialogSize="sm"
      fullWidth
      closeButtonText="Cancelar"
      actionButtonText="Cadastrar"
      actionButton={handleSubmit(onSubmit)}
    >
      <LoadingFeedback open={isLoading} />
      {!isLoading && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Label title="Selecionar classificador" lg={6} item xs={12} />
            <Controller
              as={
                <Autocomplete
                  multiple
                  options={allTags}
                  getOptionLabel={(option) => option.name}
                  getOptionSelected={(option, value) =>
                    option.id === value.id || value.id === 0
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Classificadores"
                    />
                  )}
                />
              }
              name="dataProcessTags"
              control={control}
              onChange={([, data]) => data}
            />
          </Grid>

          <Grid item xs={12}>
            <Label title="Adicionar novo classificador" lg={6} item xs={12} />
            <Controller
              as={
                <TextField
                  label="Separe por vírgulas para criar mais de um classificador"
                  color="primary"
                  variant="outlined"
                  error={!!errors.newTags}
                  helperText={
                    !!errors.newTags
                      ? errors?.newTags?.message
                      : 'Máximo de 30 caracteres por classificador'
                  }
                  fullWidth
                />
              }
              rules={{
                validate: (value) => helpers.tags.validateTagsSize(value),
              }}
              control={control}
              name="newTags"
              mode="onBlur"
            />
          </Grid>
        </Grid>
      )}
    </BaseDialog>
  )
}

DialogManageTag.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
}

export default DialogManageTag
